import React from 'react';
import NoSSR from 'react-no-ssr';
import PropTypes from 'prop-types';
import styles from './index.css';
import Chip from 'Chip';
import Ad from '@ifeng/ui_pc_ad';
import errorBoundary from '@ifeng/errorBoundary';
import NewsTitle from '../../../components/newsTitle';
import NewsList from '../../../components/newsList';
import Promote from '../../../components/promote';

class LeftNewsBox extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };

    render() {
        const {
            content: {
                choiceTitle,
                choiceList0,
                shopInChoice,
                choiceList1,
                choiceListAd,
                choiceHardAd,
                promoteInChoice,
            },
        } = this.props;

        return (
            <div className={styles.left_box}>
                <Chip id="200138" type="struct" title="凤凰精选标题" groupName="凤凰精选" content={choiceTitle}>
                    <NewsTitle size="middle" />
                </Chip>
                <Chip
                    id="255855"
                    type="recommend"
                    title="凤凰精选列表1"
                    groupName="凤凰精选"
                    content={choiceList0}
                    translate="handleNewsData">
                    <NewsList hasTitleImg size="long" />
                </Chip>
                <Chip
                    id="195858"
                    type="recommend"
                    title="凤凰精选区电商"
                    groupName="凤凰精选"
                    content={shopInChoice}
                    translate="handleNewsData">
                    <NewsList size="long" />
                </Chip>
                <Chip
                    id="195859"
                    type="recommend"
                    title="凤凰精选列表2"
                    groupName="凤凰精选"
                    content={choiceList1}
                    translate="handleNewsData">
                    <NewsList size="long" ad={choiceListAd} />
                </Chip>
                <NoSSR>
                    <Ad content={choiceHardAd} styleName={styles.dbox} />
                </NoSSR>
                {promoteInChoice && (
                    <Chip id="230191" type="struct" title="铺底推广" groupName="凤凰精选" content={promoteInChoice}>
                        <Promote />
                    </Chip>
                )}
            </div>
        );
    }
}

export default errorBoundary(LeftNewsBox);
